import React from "react";
import { CircleAlertIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { problems } from "../../data/content";
export function ProblemsSection() {
  return <section className="bg-sand px-5 py-16 sm:py-24" aria-label="Does this sound familiar" data-id="element-279" data-mp="1idh1dv5hz8j9">
      <div className="mx-auto max-w-5xl" data-id="element-280" data-mp="1dff8yjm6lwv4">
        <SectionHeading title="Does This Sound Familiar?" subtitle="If you're a plastic surgeon or another qualified medical professional studying otoplasty, you may recognize some of these situations." data-id="element-281" data-mp="2a43nv72lp40b" />

        <ul className="mt-12 grid gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-282" data-mp="21arq4lti6jkg">
          {problems.map(p => <li key={p.title} className="flex gap-4" data-id="element-283" data-mp="1wbnku69p95ze">
              <CircleAlertIcon className="mt-1 h-6 w-6 shrink-0 text-alert" aria-hidden="true" data-id="element-284" data-mp="2ts42ro4402o3" />
              <div data-id="element-285" data-mp="2p1dyyfbc07vi">
                <h3 className="font-serif text-xl sm:text-2xl font-bold leading-snug text-ink" data-id="element-286" data-mp="2p0ugmxhrrhgy">{p.title}</h3>
                <p className="mt-2 text-base sm:text-[17px] leading-relaxed text-ink/75" data-id="element-287" data-mp="126433y29ifcj">{p.text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-14 max-w-2xl space-y-3 text-center text-lg text-ink/80" data-id="element-288" data-mp="177bahw0htcio">
          <p className="font-serif text-2xl font-bold text-navy" data-id="element-289" data-mp="tbzfdnifdk18">And it shouldn't have to feel so disorganized.</p>
          <p data-id="element-290" data-mp="jfw6zzwzcp5u">Sometimes the problem isn't a lack of information.</p>
          <p data-id="element-291" data-mp="jel19ujz57c3">Sometimes the information simply isn't organized into a repeatable learning system.</p>
          <p className="font-semibold text-ink" data-id="element-292" data-mp="ogaf1hykzz3v">That's exactly why I created Otoplasty Clinical Pathway System™.</p>
        </div>

        <div className="mt-10" data-id="element-293" data-mp="egtcvaijg3cn">
          <CtaButton label="I want a structured otoplasty learning system" data-id="element-294" data-mp="eg1ho0sus7mw" />
        </div>
      </div>
    </section>;
}